import { ref } from "vue"
import { useI18n } from "vue-i18n"
import debounce from "lodash/debounce"
import axios from "axios"

export function useCustomerSearch() {
  const { t } = useI18n()

  const customers = ref([])
  const searchQuery = ref("")
  const isLoading = ref(false)
  const selectedCustomer = ref(null)

  // Normaliser un client pour le dropdown
  const normalizeCustomer = customer => ({
    id: customer.id,
    name: customer.name,
    phone: customer.phone || null,
    email: customer.email || null,
    text: customer.text || `${customer.name} (${customer.phone || "No Phone"})`,
  })

  // Sélectionner un client
  const selectCustomer = customer => {
    selectedCustomer.value = customer || null
  }

  // Rechercher les clients depuis l'API
  // exclude_unidentified hides placeholder rows (name='???', phone='BC-…')
  // that get auto-created during PL imports — they should never appear
  // in a "pick the customer for this parcel" dropdown.
  // exclude_merged hides rows merged into another contact.
  const _searchCustomers = async query => {
    isLoading.value = true
    try {
      const params = new URLSearchParams({
        q: query || "",
        exclude_unidentified: "1",
        exclude_merged: "1",
      })
      const response = await axios.get(`/shipment/customers?${params.toString()}`)

      let data = response.data?.data || []

      // Map pour supprimer les doublons
      const customerMap = new Map()

      data.forEach(c => {
        if (c?.id) customerMap.set(c.id, normalizeCustomer(c))
      })

      let uniqueCustomers = Array.from(customerMap.values())

      // Ajouter l'option "Create New" si aucun match exact
      const searchLower = (query || "").toLowerCase()

      const hasExactMatch = uniqueCustomers.some(
        c => (c.text || "").toLowerCase() === searchLower,
      )

      if (!hasExactMatch && query) {
        uniqueCustomers.unshift({
          id: "new",
          name: query,
          text: `Create New Customer: ${query}`,
          isNew: true,
        })
      }

      customers.value = uniqueCustomers
      console.log("customers value", customers.value)
    } catch (err) {
      console.error("Customer search error:", err)
      customers.value = []
    } finally {
      isLoading.value = false
    }
  }

  // Version debounce pour éviter trop de requêtes API
  const searchCustomers = debounce(_searchCustomers, 300)

  return {
    customers,
    searchQuery,
    isLoading,
    selectedCustomer,
    selectCustomer,
    searchCustomers,
  }
}
